import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  printersWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
  printPosition: {
    margin: theme.spacing(4.5, 0),
  },
  reloadPrintersButton: {
    marginTop: theme.spacing(3.375),
  },
  printersModelWrapper: {
    margin: theme.spacing(4.5, 0),
  },
  printTypeSelect: {
    width: 460,
  },
}))

export default useStyles
